import S from 'common/service/sanctuary';
import { update, addIndex } from 'ramda';

import {
  CLEAR_CONSTRAINTS,
  ADD_CONSTRAINT,
  REMOVE_CONSTRAINT,
} from './actions';

import {
  actions as constraintActions,
} from '../constraint';

import {
  getDefaultOperator,
} from './selectors';

import constraintReducer, { defaultState as constraintState } from '../constraint/reducer';

export const defaultState = criteria => ({
  constraints: [
    constraintState(getDefaultOperator(criteria)),
  ],
});

export const clear = state => ({
  ...state,
  ...defaultState,
});

export const addConstraint = (state, { constraint }) => ({
  ...state,
  constraints: S.append({
    ...constraintState(getDefaultOperator(state)),
    ...constraint,
  }, state.constraints),
});

export const removeConstraint = (state, { index }) => ({
  ...state,
  constraints: addIndex(S.filter)((_, idx) => idx !== index, state.constraints),
});

const updateConstraint = (state, { index, constraint }) => ({
  ...state,
  constraints: update(index, constraint, state.constraints),
});

export default (state = defaultState(), action) => {
  const reducer = {
    [CLEAR_CONSTRAINTS]: clear,
    [ADD_CONSTRAINT]: addConstraint,
    [REMOVE_CONSTRAINT]: removeConstraint,
  }[action.type];

  if (reducer) {
    return reducer(state, action);
  }

  if (action.type && S.elem(action.type, constraintActions.TYPES)) {
    return S.maybe(
      state,
      constraint => updateConstraint(state, {
        index: action.constraintIndex,
        constraint: constraintReducer(constraint, action),
      }),
      S.at(action.constraintIndex, state.constraints),
    );
  }

  return state;
};
